import React, { useState } from "react";

const AboutMe = () => {
  const [activeButton, setActiveButton] = useState("UI/UX");
  const [buttonText, setButtonText] = useState({
    "UI/UX": "I have an interest and ability in designing intuitive and engaging user interfaces with Figma. In creating UI/UX designs, I strive to provide the maximum user experience.",
    "FRONTEND": "I use various technologies such as ReactJs, NextJs and TailwindCSS to create attractive and responsive interfaces.",
    "BACKEND": "Handle database, server and APIs with ExpressJs and other frameworks.",
    "APIs": "Develop clean and robust REST API's and microservices with NodeJs."
  });

  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName === activeButton ? null : buttonName);
  };
  return (
    <div id="about" className="cursor-default">
      <div className="flex items-center justify-center p-1 md:p-4 border-y mb-6 md:mb-12">
          <h1 className="md:text-4xl font-bold md:font-extrabold whitespace-nowrap overflow-y-hidden">
            UI/UX • FRONTEND • BACKEND • APIs & MICROSERVICES
          </h1>
      </div>
      <div className="pb-10 md:pb-20 md:px-20 border-b">
        <h1 className="font-bold text-[#FF6812] text-xl md:text-4xl pb-2 md:pb-6">About Me</h1>
        <p className="text-sm md:text-xl pb-6 md:pb-12">
          I'm <span className="text-[#FF6812]">Muhammad Jindan</span>, a passionate and problem-solving-oriented <span className="text-[#FF6812]">Software Engineer</span> who is committed to continuously developing knowledge and skills, delivering clean code, and learning new technologies. I am currently interested in improving understanding in software testing and database management to improve the quality of software produced.
        </p>
        <div className="flex flex-col md:flex-row bg-[#202020] rounded-md md:rounded-xl md:pr-8">
          <div className="flex justify-center bg-[#FF6812] rounded-t-md md:rounded-l-xl p-6 md:p-14 whitespace-nowrap md:mr-8 font-bold md:text-2xl">
            WHAT I DO
          </div>
          <div className="flex flex-col gap-2 p-6 md:pt-6 md:pb-6">
            <div className="flex items-center gap-4 font-bold md:font-extrabold md:text-xl text-zinc-500 overflow-y-hidden whitespace-nowrap">  
              <button className={`${
                  activeButton === "UI/UX" ? "text-white transition-all ease-in-out duration-500" : ""
                } focus:outline-none`}
                onClick={() => handleButtonClick("UI/UX")}>UI/UX</button>
              <p className="text-white">•</p>
              <button className={`${
                  activeButton === "FRONTEND" ? "text-white transition-all ease-in-out duration-500" : ""
                } focus:outline-none`}
                onClick={() => handleButtonClick("FRONTEND")}>FRONTEND</button>
              <p className="text-white">•</p>
              <button className={`${
                  activeButton === "BACKEND" ? "text-white transition-all ease-in-out duration-500" : ""
                } focus:outline-none`}
                onClick={() => handleButtonClick("BACKEND")}>BACKEND</button>
              <p className="text-white">•</p>
              <button className={`${
                  activeButton === "APIs" ? "text-white transition-all ease-in-out duration-500" : ""
                } focus:outline-none`}
                onClick={() => handleButtonClick("APIs")}>APIs & MICROSERVICES</button>
            </div>
            <p className="text-xs md:text-base">
              {buttonText[activeButton]}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutMe;
